import {useState} from 'react'
import styled, {keyframes} from 'styled-components'
import PDFModal from '../../../globalComponents/PDFModal'
import privFile from '../../../assets/files/Politica_cookie.pdf'

const COOKIE_CONSENT_KEY = 'cookie_consent'

const slideUp = keyframes`
    from { transform: translateY(100%); opacity: 0; }
    to { transform: translateY(0); opacity: 1; }
`

const Banner = styled.div`
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #1e1e2e;
    border-top: 1px solid #2e2e4a;
    padding: 16px 24px;
    z-index: 9998;
    display: flex;
    flex-direction: column;
    gap: 12px;
    animation: ${slideUp} 0.3s ease-out;
    box-shadow: 0 -4px 24px rgba(0, 0, 0, 0.3);
`

const Row = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
`

const Text = styled.p`
    color: #c8c8d8;
    font-size: 13px;
    line-height: 1.5;
    margin: 0;
    flex: 1;
    min-width: 220px;
`

const PolicyLink = styled.span`
    color: #3394ef;
    cursor: pointer;
    text-decoration: underline;

    &:hover {
        opacity: 0.8;
    }
`

const ButtonGroup = styled.div`
    display: flex;
    gap: 10px;
    flex-shrink: 0;
`

const AcceptButton = styled.button`
    background: linear-gradient(90deg, #3ffe81, #3394ef);
    color: #050b29;
    border: none;
    border-radius: 6px;
    padding: 8px 20px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;

    &:hover {
        opacity: 0.9;
    }
`

const RefuseButton = styled.button`
    background: transparent;
    color: #888;
    border: 1px solid #444;
    border-radius: 6px;
    padding: 8px 16px;
    font-size: 13px;
    cursor: pointer;
    white-space: nowrap;

    &:hover {
        border-color: #888;
        color: #c8c8d8;
    }
`

const WarningBox = styled.div`
    background-color: #2a1a1a;
    border: 1px solid #7a2020;
    border-radius: 6px;
    padding: 12px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
`

const WarningText = styled.p`
    color: #f28b82;
    font-size: 13px;
    margin: 0;
    flex: 1;
    min-width: 220px;
`

export function hasCookieConsent(): boolean {
    return localStorage.getItem(COOKIE_CONSENT_KEY) === 'accepted'
}

export default function CookieBanner() {
    const [visible, setVisible] = useState(!hasCookieConsent())
    const [refused, setRefused] = useState(false)
    const [pdf, setPdf] = useState<any>(null)

    if (!visible) return null

    const handleAccept = () => {
        localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted')
        setVisible(false)
    }

    const handleRefuse = () => {
        setRefused(true)
    }

    return (
        <>
            <Banner>
                {!refused ? (
                    <Row>
                        <Text>
                            Utilizamos cookies essenciais para manter sua sessão
                            ativa e garantir o funcionamento do sistema. Ao
                            continuar, você concorda com nossa{' '}
                            <PolicyLink onClick={() => setPdf(privFile)}>
                                Política de Privacidade
                            </PolicyLink>
                            .
                        </Text>
                        <ButtonGroup>
                            <RefuseButton onClick={handleRefuse}>
                                Recusar
                            </RefuseButton>
                            <AcceptButton onClick={handleAccept}>
                                Aceitar cookies
                            </AcceptButton>
                        </ButtonGroup>
                    </Row>
                ) : (
                    <WarningBox>
                        <WarningText>
                            ⚠️ Sem aceitar os cookies, o sistema não funcionará
                            corretamente. Utilizamos cookies para manter sua
                            sessão de acesso ativa. Você precisará aceitá-los
                            para utilizar a plataforma.
                        </WarningText>
                        <ButtonGroup>
                            <RefuseButton onClick={() => setRefused(false)}>
                                Voltar
                            </RefuseButton>
                            <AcceptButton onClick={handleAccept}>
                                Aceitar cookies
                            </AcceptButton>
                        </ButtonGroup>
                    </WarningBox>
                )}
            </Banner>
            {!!pdf && <PDFModal item={pdf} setModal={setPdf} />}
        </>
    )
}
